// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-icon {
  --v-icon-size-multiplier: 1;
  align-items: center;
  display: inline-flex;
  font-feature-settings: "liga";
  height: 1em;
  justify-content: center;
  letter-spacing: normal;
  line-height: 1;
  position: relative;
  opacity: var(--v-icon-opacity, 1);
  text-indent: 0;
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  width: 1em;
  min-width: 1em;
}
:where(.vuetify-styles) .v-icon--clickable {
  cursor: pointer;
}
:where(.vuetify-styles) .v-icon--disabled {
  pointer-events: none;
  opacity: 0.38;
}
:where(.vuetify-styles) .v-icon--size-x-small {
  font-size: calc(var(--v-icon-size-multiplier) * 1em);
}
:where(.vuetify-styles) .v-icon--size-small {
  font-size: calc(var(--v-icon-size-multiplier) * 1.25em);
}
:where(.vuetify-styles) .v-icon--size-default {
  font-size: calc(var(--v-icon-size-multiplier) * 1.5em);
}
:where(.vuetify-styles) .v-icon--size-large {
  font-size: calc(var(--v-icon-size-multiplier) * 1.75em);
}
:where(.vuetify-styles) .v-icon--size-x-large {
  font-size: calc(var(--v-icon-size-multiplier) * 2em);
}

:where(.vuetify-styles) .v-icon__svg {
  fill: currentColor;
  width: 100%;
  height: 100%;
}

:where(.vuetify-styles) .v-icon--start {
  margin-inline-end: 8px;
}

:where(.vuetify-styles) .v-icon--end {
  margin-inline-start: 8px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VIcon/VIcon.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,UAAU;EACV,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,oDAAoD;AACtD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".v-icon {\n  --v-icon-size-multiplier: 1;\n  align-items: center;\n  display: inline-flex;\n  font-feature-settings: \"liga\";\n  height: 1em;\n  justify-content: center;\n  letter-spacing: normal;\n  line-height: 1;\n  position: relative;\n  opacity: var(--v-icon-opacity, 1);\n  text-indent: 0;\n  text-align: center;\n  user-select: none;\n  vertical-align: middle;\n  width: 1em;\n  min-width: 1em;\n}\n.v-icon--clickable {\n  cursor: pointer;\n}\n.v-icon--disabled {\n  pointer-events: none;\n  opacity: 0.38;\n}\n.v-icon--size-x-small {\n  font-size: calc(var(--v-icon-size-multiplier) * 1em);\n}\n.v-icon--size-small {\n  font-size: calc(var(--v-icon-size-multiplier) * 1.25em);\n}\n.v-icon--size-default {\n  font-size: calc(var(--v-icon-size-multiplier) * 1.5em);\n}\n.v-icon--size-large {\n  font-size: calc(var(--v-icon-size-multiplier) * 1.75em);\n}\n.v-icon--size-x-large {\n  font-size: calc(var(--v-icon-size-multiplier) * 2em);\n}\n\n.v-icon__svg {\n  fill: currentColor;\n  width: 100%;\n  height: 100%;\n}\n\n.v-icon--start {\n  margin-inline-end: 8px;\n}\n\n.v-icon--end {\n  margin-inline-start: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
